import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["logo", "hamburger"]
    static values = {
        searchActive: { type: Boolean, default: false }
    }

    connect() {
        this.element.addEventListener('search-bar:toggle', this.handleSearchToggle.bind(this));
    }

    disconnect() {
        this.element.removeEventListener('search-bar:toggle', this.handleSearchToggle.bind(this));
    }

    handleSearchToggle(event) {
        this.searchActiveValue = event.detail.active;
    }

    searchActiveValueChanged() {
        if (window.innerWidth < 1024) {
            if (this.searchActiveValue) {
                if (this.hasLogoTarget) {
                    this.logoTarget.classList.add("hidden");
                    this.logoTarget.classList.remove("flex");
                }
                if (this.hasHamburgerTarget) {
                    this.hamburgerTarget.classList.add("hidden");
                    this.hamburgerTarget.classList.remove("flex");
                }
            } else {
                if (this.hasLogoTarget) {
                    this.logoTarget.classList.remove("hidden");
                    this.logoTarget.classList.add("flex");
                }
                if (this.hasHamburgerTarget) {
                    this.hamburgerTarget.classList.remove("hidden");
                    this.hamburgerTarget.classList.add("flex");
                }
            }
        } else {
            if (this.hasLogoTarget) {
                this.logoTarget.classList.remove("hidden");
                this.logoTarget.classList.add("flex");
            }
        }
    }
}